export default function QueryStringParser(name: string): string {
	name = name.replace(/[[\]]/g, '\\$&');

	const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`, 'i');
	const results: RegExpExecArray = regex.exec(window.location.href) as RegExpExecArray;

	if (!results || !results[2]) {
		return '';
	}

	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
